import { useEffect, useState, useRef } from 'react'
import {t} from 'i18next'
import GoogleMap from 'google-maps-react-markers'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

import env from '../../../env/src_config';
import DictionaryInfoButton from '../../dictionary/DictionaryInfoButton';

const Marker = () => (
    <div><i className="fa fa-map-marker" style={{ fontSize: '22px', color: 'red' }}></i></div>
);

const Maps = ({coords, changeLocation, showDictionary}) => {
    const [selectedCoords, setSelectedCoords] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    // google maps
    const [mapReady, setMapReady] = useState(false)
    const mapRef = useRef(null)

    useEffect(() => {
        if (coords) {
            let splitCoords = coords.split(',');
            let lat = parseFloat(splitCoords[0]);
            let lng = parseFloat(splitCoords[1]);

            if (isNaN(lat) || isNaN(lng)) {
                console.log("Invalid coordinates")
                return;
            }

            setSelectedCoords({ lat, lng });
        } else {
            setSelectedCoords(null);
        }

    }, [coords])

    const modaltoggle = () => setModalOpen(val => !val);

    const selectLocation = () => {
        changeLocation(selectedCoords?.lat + ',' + selectedCoords?.lng)
        modaltoggle();
    }

    const onGoogleApiLoaded = ({ map, maps }) => {
        mapRef.current = map
        setMapReady(true)

        window.google.maps.event.addDomListener(mapRef.current, "click", (e) => {
            if (e.latLng && e.latLng.lat && e.latLng.lng) {
                setSelectedCoords({ lat: e.latLng.lat(), lng: e.latLng.lng() });
            }
        });
    }

    return (
        <div>
            <div className="d-flex align-items-center mt-2">
                <Button color="primary" className="btn-sm" onClick={modaltoggle}>{t('Google maps')}</Button>
                {showDictionary && <DictionaryInfoButton code="client_facilities.form.google_location_button" id="client_facilities.form.google_location_button" />}
            </div>
            <Modal isOpen={modalOpen} toggle={modaltoggle} centered size="xl">
                <ModalHeader toggle={modaltoggle}>
                    {selectedCoords ?
                        selectedCoords.lat + ', ' + selectedCoords.lng : <span>&nbsp;</span>
                    }
                </ModalHeader>
                <ModalBody>
                    <div style={{ height: '600px', width: '100%' }}>
                        <GoogleMap
                            apiKey={env.google_maps_api_key}
                            defaultCenter={{ lat: 46.1203255, lng: 14.8156076 }}
                            defaultZoom={9}
                            mapMinHeight="600px"
                            onGoogleApiLoaded={onGoogleApiLoaded}
                        >
                            {selectedCoords &&
                                <Marker
                                    key={"service-marker-facility"}
                                    lat={selectedCoords?.lat}
                                    lng={selectedCoords?.lng}
                                    markerId={1}
                                />
                            }
                        </GoogleMap>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className='text-end'>
                        <Button color="primary" className='me-2' onClick={selectLocation}>{t('select')}</Button>
                    </div>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default Maps